export default "__VITE_ASSET__DR$SVVBB__"